import { simpleDeepEqual } from './simpleDeepEqual';

const objectIncludes = (sourceObj, referenceObj) =>
   Object.entries(referenceObj).reduce(
      (acc, [key, val]) => acc && simpleDeepEqual(sourceObj[key], val),
      true
   );

export { objectIncludes };
